export default __webpack_public_path__ + "static/165-a9ce9c1073b50a584db60db2f5e6a99b.jpg";